<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Statistics</b-card-title>
      <!-- <b-card-text class="font-small-2 mr-25 mb-0">
        Updated on {{data.datetime}}
      </b-card-text> -->
    </b-card-header>
    <b-card-body class="m-0 p-1">
      <b-row>
        <b-col
          xl="12"
          sm="12"
        >
          <b-media no-body>
            <b-media-aside
            >
              <b-avatar
                size="30"
                variant="light-primary"
              >
                <feather-icon
                  size="15"
                  icon="LogInIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.check_in}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                CHECK IN
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="12"
          sm="12"
          class="mt-2"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="30"
                variant="light-info"
              >
                <feather-icon
                  size="15"
                  icon="ClockIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.pt}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                IN HOSUE PT
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="12"
          sm="12"
           class="mt-2"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="30"
                variant="light-warning"
              >
                <feather-icon
                  size="15"
                  icon="TrendingUp"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.rental}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                RENTAL PT
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="12"
          sm="12"
           class="mt-2"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="30"
                variant="light-success"
              >
                <feather-icon
                  size="15"
                  icon="TrelloIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.class}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                CLASS
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  created() {
  //  this.get_stats()
  },
  data() {
    return {
      stats : {},
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },

}
</script>
